import { HTMLFontSize } from "configs/variables";

/**
 * Convert from "pixel" to "rem"
 */
export const rem = (fs: number) => `${fs / HTMLFontSize}rem`;

/**
 * Convert from "pixel" to "lineHeight"
 */
export const lineHeight = (
  fs: number,
  basedOnRem: boolean | undefined = true
) => `${fs / HTMLFontSize}${basedOnRem ? "rem" : ""}`;
